__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "googleDocViewerWebapp";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@angular/common", "12.2.17", () => (Promise.all([__webpack_require__.e(8819), __webpack_require__.e(3595)]).then(() => (() => (__webpack_require__(/*! ./node_modules/@angular/common/__ivy_ngcc__/fesm2015/common.js */ 3595))))));
			register("@angular/core", "12.2.17", () => (Promise.all([__webpack_require__.e(4973), __webpack_require__.e(2435)]).then(() => (() => (__webpack_require__(/*! ./node_modules/@angular/core/__ivy_ngcc__/fesm2015/core.js */ 2435))))));
			register("@angular/router", "12.2.17", () => (Promise.all([__webpack_require__.e(4973), __webpack_require__.e(8819), __webpack_require__.e(1121), __webpack_require__.e(4239)]).then(() => (() => (__webpack_require__(/*! ./node_modules/@angular/router/__ivy_ngcc__/fesm2015/router.js */ 4239))))));
			register("@lst/lst-auth", "2.0.6", () => (Promise.all([__webpack_require__.e(4973), __webpack_require__.e(8819), __webpack_require__.e(2279), __webpack_require__.e(1966)]).then(() => (() => (__webpack_require__(/*! ./node_modules/@lst/lst-auth/__ivy_ngcc__/fesm2015/lst-lst-auth.js */ 1966))))));
			register("@ngx-translate/core", "13.0.0", () => (__webpack_require__.e(6718).then(() => (() => (__webpack_require__(/*! ./node_modules/@ngx-translate/core/__ivy_ngcc__/fesm2015/ngx-translate-core.js */ 6718))))));
			register("rxjs/operators", "6.6.7", () => (Promise.all([__webpack_require__.e(4556), __webpack_require__.e(9011)]).then(() => (() => (__webpack_require__(/*! ./node_modules/rxjs/_esm2015/operators/index.js */ 9011))))));
			register("rxjs", "6.6.7", () => (Promise.all([__webpack_require__.e(4556), __webpack_require__.e(1093)]).then(() => (() => (__webpack_require__(/*! ./node_modules/rxjs/_esm2015/index.js */ 1093))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};